<template>
  <div>
    <div class="loader d-flex justify-content-center" v-if="this.loading">
        <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
    </div>
    <div class="attr-table" v-else-if="extraInfo != null && extraInfo.length != 0">
        <b-row v-for="[key, value] in extraInfo" :key="key">
            <b-col>{{ key }}</b-col>
            <b-col>{{ value }}</b-col>
        </b-row>
    </div>
    <p v-else> {{ $t('map.vehicle_can_data.loading_error') }} </p>
  </div>
  
</template>

<script>
import mapstore from '@/store/map/mapstore';
import vcd from '@/components/Realtime/VehicleCANData.js';

export default {
  name: 'VehicleCANData',
  props: {
    itemId: { default: null },
  },
  data: function () {
    return {
      loading: true,
      item: null,
      spatialData: null,
      formattedGpsTime: '',
    }
  },
  computed: {
    vehicles() {
      return this.$store.state.mapstore.vehiclesForTable;
    },
    extraInfo() {
      let extraInfo = this.spatialData?.properties?.extraInfo;
      if (extraInfo != null) {
        return vcd.filterAndFormatList(extraInfo);
      } else {
        return null;
      }
    }
  },
  mounted() {
    this.$store.dispatch('mapstore/getVehiclesForTable');
    this.fetchVehicleCANData(this.$store.state.mapstore.vehiclesForTable);
    this.interval = setInterval(() => { 
      this.$store.dispatch('mapstore/getVehiclesForTable', 15)
    }, 10000 );
  },
  beforeCreate: function () {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule('mapstore', mapstore);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    fetchVehicleCANData(data) {
      const found = data.find((i) => i.vehicleId == this.itemId)
      if (found && found.spatialData) {
        this.spatialData = found.spatialData;
        this.formattedGpsTime = vcd.formatTimestamp(
          this.spatialData.properties.gpsTimestamp
        )
        this.loading = false;
      }
    },
  },
  watch: {
    vehicles(newValue) {
      this.fetchVehicleCANData(newValue);
    }
  }
}
</script>

<style scoped lang="scss">
.row {
  font-size: 0.75rem;
  white-space: pre-wrap;
  margin-bottom: 5px;
}

.col:first-child {
  font-weight: normal;
}
</style>
